<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'advance-search-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>
      <el-form :model="form" label-position="right" class="">
        <el-form-item label="Trích yếu" class="formItem">
          <el-input
            v-model="advanceSearchForm.quote"
            size="medium"
            class=""
            placeholder="-"
          ></el-input>
        </el-form-item>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Nội dung văn bản" class="formItem">
              <el-input
                v-model="advanceSearchForm.fileContent"
                v-focus.native
                class=""
                placeholder="-"
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Độ khẩn:" class="formItem">
          <el-select
            clearable
            class="style-fullWidth"
            v-model="advanceSearchForm.priorityId"
            filterable
            placeholder="-"
            size="medium"
          >
            <el-option
              v-for="item in priorities"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Loại văn bản:" class="formItem">
          <el-select
            clearable
            class="style-fullWidth"
            v-model="advanceSearchForm.docTypeId"
            filterable
            placeholder="-"
            size="medium"
          >
            <el-option
              v-for="item in docTypes"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Nơi nhận bên trong" class="formItem">
          <template #label>
            <span class="flex-row flex__right">
              Nơi nhận bên trong &nbsp;
              <i
                class="fas fa-cog advance-search color__cyan clickable"
                @click="selectReceiveDeptId"
              ></i>
            </span>
          </template>
          <el-select
            filterable
            clearable
            v-model="advanceSearchForm.receiveDeptId"
            size="medium"
            placeholder="-"
            class="style-fullWidth"
          >
            <el-option
              v-for="item in departments"
              :label="item.deptName"
              :key="item.id"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Nơi nhận bên ngoài"
          prop="otherReceivePlaces"
          class="formItem"
        >
          <el-input
            type="textarea"
            class=""
            placeholder="-"
            rows="0"
            v-model="advanceSearchForm.otherReceivePlaces"
          ></el-input>
        </el-form-item>
        <vbdi-sort-select-2 @selectedSort="selectedSort" :form="form" ref="vbDiSortSelect">

        </vbdi-sort-select-2>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fas fa-search font-size__small"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset"
        >Khởi tạo
        </el-button>
      </div>
      <selectDepartmentDialog
        :isOpen="isOpenSelectDepartmentDialog"
        v-if="isEnableSelectDepartmentDialog"
        @closed="isEnableSelectDepartmentDialog = false"
        @closeDialog="isOpenSelectDepartmentDialog = false"
        @change="publisherDepartmentChange"
      >
      </selectDepartmentDialog>
    </template>
  </dialogTemplate>
</template>

<script>
import h from "../../../services/h";
import constants from "../../../constants";
import categoryViewService from "../../../services/categoryViewService";
import departmentService from "../../../services/departmentService";
import VbdiSortSelect2 from "../../common/vbdi-sort-select-2";

export default {
  name: "chobanhanh-advance-search",
  props: ["isOpen", "form"],
  components: {
    VbdiSortSelect2,
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    selectDepartmentDialog: () =>
      import("../../common/commonSelectDepartmentDialog")
  },

  data() {
    return {
      sortList: [],
      receiveDepartments: [],
      docTypes: [],
      departments: [],
      priorities: [],

      selectType: null,
      isOpenSelectDepartmentDialog: false,
      isEnableSelectDepartmentDialog: false,

      advanceSearchForm: {
        quote: null,
        priorityId: null,
        priorityName: null,
        docTypeId: null,
        receiveDeptId: null,
        otherReceivePlaces: null,
        fileContent: null,
      }
    };
  },

  watch: {
    isOpenSelectDepartmentDialog(newValue) {
      newValue && (this.isEnableSelectDepartmentDialog = newValue);
    }
  },

  mounted() {
    this.loadCategories();
    this.loadDepartments();
    this.initForm();
  },

  methods: {
    selectedSort(event){
      this.sortList=event.sortList;
    },
    initForm() {
      this.advanceSearchForm.quote = this.form.quote;
      this.advanceSearchForm.priorityId = this.form.priorityId;
      this.advanceSearchForm.priorityName = this.form.priorityName;
      this.advanceSearchForm.docTypeId = this.form.docTypeId;
      this.advanceSearchForm.receiveDeptId = this.form.receiveDeptId;
      this.advanceSearchForm.otherReceivePlaces = this.form.otherReceivePlaces;
      this.advanceSearchForm.fileContent = this.form.fileContent;
    },

    selectPublishId() {
      this.isOpenSelectDepartmentDialog = true;
      this.selectType = "publish";
    },

    selectReceiveDeptId() {
      this.isOpenSelectDepartmentDialog = true;
      this.selectType = "receive";
    },

    publisherDepartmentChange(event) {
      let department = event.selectedDepartment;
      if (this.selectType === "publish")
        this.advanceSearchForm.publisherId = department ? department.id : null;
      else
        this.advanceSearchForm.receiveDeptId = department
          ? department.id
          : null;
      this.isOpenSelectDepartmentDialog = false;
    },

    loadDepartments() {
      departmentService.findAll({ sort: "deptName,asc" }).then(response => {
        this.departments = response.data;
        this.prepareReceiveDepartments();
      });
    },

    prepareReceiveDepartments(publisherId) {
      this.receiveDepartments = departmentService.prepareReceiveDepartments(
        publisherId,
        this.departments
      );
    },

    loadCategories() {
      h.each(
        [
          constants.CATEGORY_GROUP_CODE.PRIORITY,
          constants.CATEGORY_GROUP_CODE.DOC_TYPE
        ],

        item => {
          categoryViewService
            .findAll(
              {groupCode: item},
              {sort: "order,asc", page: 0, size: 1000}
            )
            .then(response => {
              switch (item) {
                case constants.CATEGORY_GROUP_CODE.PRIORITY:
                  return (this.priorities = response.data);
                case constants.CATEGORY_GROUP_CODE.DOC_TYPE:
                  return (this.docTypes = response.data);
              }
            });
        }
      );
    },

    search() {
      this.$emit("doSearch", {advanceSearchForm: this.advanceSearchForm,sortList:this.sortList});
      this.$emit("closeDialog");
    },

    reset() {
      this.advanceSearchForm.quote = null;
      this.advanceSearchForm.docTypeId = null;
      this.advanceSearchForm.priorityId = null;
      this.advanceSearchForm.priorityName = null;
      this.advanceSearchForm.receiveDeptId = null;
      this.advanceSearchForm.otherReceivePlaces = null;
      this.advanceSearchForm.fileContent = null;
      this.$refs.vbDiSortSelect.resetData();
      this.sortList=[];
    }
  }
};
</script>

<style scoped>
.form {
  padding: 12px 20px 0 20px;
}

.filter {
  background-color: #d5d7dd;
  border-radius: 4px;
  padding: 13px 10px;
  margin-bottom: 10px;
}

.filter .item {
  color: #007aff;
  font-size: 15px;
  font-weight: 500;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/chobanhanh-advance-search.vue